import { render, staticRenderFns } from "./ShareProjectDetails.vue?vue&type=template&id=47ba8aaa"
import script from "./ShareProjectDetails.vue?vue&type=script&lang=js"
export * from "./ShareProjectDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports